const ERSTE_PAUSE = 1000;
const LAENGSTE_PAUSE = 30_000;

type Hoerer = { offen: () => void; nachricht: (daten: string) => void };

/** Ereignisstrom, der sich nach endgültigem Abbruch (etwa 502 beim Neustart hinter einem Proxy) selbst neu verbindet. */
export function oeffneStrom(url: string, h: Hoerer, erzeuge: (url: string) => EventSource = (u) => new EventSource(u)): () => void {
  let quelle: EventSource | null = null;
  let pause = ERSTE_PAUSE;
  let zeitgeber: ReturnType<typeof setTimeout> | undefined;
  let geschlossen = false;

  const verbinden = () => {
    const q = erzeuge(url);
    quelle = q;
    q.onopen = () => {
      pause = ERSTE_PAUSE;
      h.offen();
    };
    q.onmessage = (m) => h.nachricht(m.data);
    q.onerror = () => {
      if (geschlossen || q.readyState !== 2) return;
      zeitgeber = setTimeout(verbinden, pause);
      pause = Math.min(pause * 2, LAENGSTE_PAUSE);
    };
  };

  verbinden();
  return () => {
    geschlossen = true;
    clearTimeout(zeitgeber);
    quelle?.close();
  };
}
